export default __webpack_public_path__ + "static/media/II-2018.2e8ec6e2.pdf";